/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* vDEV */
(() => {
  window.themeObj = {};
    
    window.themeObj.init = () => {
      const obj = window.themeObj;
      
      obj.sections.init();
      obj.templates.init();
    },
      
    window.themeObj.tools = {
      
      cookie: {
        
        get: (name) => {
          const value = `; ${document.cookie}`;
    
          if (document.cookie.includes(`; ${name}=`)) {
            const parts = value.split(`; ${name}=`);
            
            if (parts.length === 2) {
              return parts.pop().split(';').shift();
            }
          }
    
          return '';
        },
        
        set: (name, value) => {
          var expires = '';
          
          var days = 365;
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          
          const cookieText = `${name}=${value}; expires=${date.toUTCString()}; domain=.${window.location.hostname}; path=/`;
          document.cookie = cookieText;
        }
      }
    };
    
    window.themeObj.sections = {
      
      init: function() {
        const obj2 = window.themeObj.sections;
        
        obj2.header.init();
  
        obj2.advancedFAQ();
        
        obj2.mediaBrandsSlider();
        obj2.mediaCards();
        obj2.mediaContactForm();
      
        obj2.productItemColors();
        
        if (document.body.classList.contains('template-product')) {
          obj2.productPopups();
        }
      },
      
      header: {
        init: function() {
          window.themeObj.sections.header.event();
          
          addEventListener('scroll', function() {
            window.themeObj.sections.header.event();
          });
        },
        event: function() {
          const header = document.querySelector('.Header');
  
          if (header) {
            
            if (window.pageYOffset > header.offsetHeight) {
              header.classList.add('Header--sticky');
              header.parentNode.classList.add('shopify-section--header--sticky');
            
            } else {
              header.classList.remove('Header--sticky');
              header.parentNode.classList.remove('shopify-section--header--sticky');
            }
          }
        }
      },
      
      productPopups: () => {
        const obj2 = this;
        
        class N8nForm extends HTMLElement {
  
          settings = {
            type: this.getAttribute('data-form-type'),
            form: this.querySelector('form'),
            button: this.querySelector('button[data-n8n-form--action="submit"]')
          }
  
          constructor() {
            super();
            
            const obj3 = this;
  
            obj3.events();
            
            obj3.variantsField();
            obj3.storesField();
          }
  
          events() {
            const obj3 = this;
  
            obj3.settings.form.addEventListener('submit', (event) => {
              event.preventDefault();
              event.stopPropagation();
              
              obj3.form__submit();
              
              return false;
            });
  
            obj3.settings.button.addEventListener('click', () => {
              obj3.form__submit();
            });
          }
  
          /* Field: Variants */
          variantsField() {
            const obj3 = this;
  
            const productForm__wrapper = document.querySelector('.Product__Info');
  
            if (!productForm__wrapper) {
              return false;
            }
            
            const productForm = productForm__wrapper.querySelector('form');
             
            if (!productForm) {
              return false;
            }
  
            const productVariants = productForm__wrapper.querySelectorAll('.ProductForm__Variants .SizeSwatchList input.SizeSwatch__Radio[type="radio"][name="option-0"]');

            if (!productVariants.length) {
              return false;
            }
            
            productVariants.forEach((productVariant) => {
  
              productVariant.addEventListener('change', () => {
                const productVariant__sku = obj3.querySelector('[data-n8n-form--name="sku"]');
  
                if (productVariant__sku) {
                  productVariant__sku.value = productVariant.getAttribute('data-variant-sku');
                }
  
                const productVariant__quantity = obj3.querySelector('[data-n8n-form--name="product_variant_qty"]');
  
                if (productVariant__quantity) {
                  productVariant__quantity.value = parseInt(productVariant.getAttribute('data-variant-quantity'));
  
                  const modalOpener = document.querySelector(`#add-to-cart-form input.btn[data-target="#productPopup--${obj3.settings.type}"]`);
  
                  if (modalOpener) {
                    
                    if (productVariant__quantity.value > 0) {
                      modalOpener.removeAttribute('disabled');
                      
                    } else {
                      modalOpener.setAttribute('disabled', 'disabled');
                    }
                  }
                }
  
                const productVariant__id = obj3.querySelector('[data-n8n-form--name="product_variant_id"]');
  
                if (productVariant__id) {
                  productVariant__id.value = productForm__wrapper.querySelector('[name="id"]').value;
                }
  
                const productVariant__value = obj3.querySelector('[data-n8n-form--name="shopify_option1"]');
  
                if (productVariant__value) {
                  productVariant__value.value = productVariant.value;
                }
                
                const productVariant__imageUrl = obj3.querySelector('[data-n8n-form--name="image_url"]');
  
                if (productVariant__imageUrl) {
                  productVariant__imageUrl.value = productVariant.getAttribute('data-variant-image-url');
                }
              });
            });
          }
          /* /Field: Variants */
  
          /* Field: Stores */
          storesField() {
            const obj3 = this;

            document.addEventListener('theme:modal:opened', (event) => {
              const modal = event.detail.modal;

              if (!modal) {
                return false;
              }

              const modalId = `modal-${modal.id}`;

              if (modal.id != `modal-${obj3.settings.type}`) {
                return false;
              }

              obj3.storesField__render();
            });
          }
          
          async storesField__render() {
            const obj3 = this;
            
            let items;
  
            const cookieItems = obj3.storesField__getCookieItems();
  
            if (cookieItems.length) {
              items = cookieItems;
            
            } else {
              items = await obj3.storesField__getRemoteItems();
  
              if (items && items.length) {
                await obj3.storesField__setCookieItems(items);
              }
            }
  
            await obj3.storesField__renderByItems(items);
          }
  
          async storesField__renderByItems(items) {
            const obj3 = this;
            
            if (!items || !items.length) {
              return false;
            }
  
            let formField__nativeSelect = obj3.settings.form.querySelector('select[data-n8n-form--name="store"]');
  
            if (!formField__nativeSelect || formField__nativeSelect.classList.contains('is-rendered')) {
              return false;
            }
  
            formField__nativeSelect.classList.add('is-rendered');
  
            /* Availability */
            const productTags = JSON.parse(document.getElementById('product-json-tags').innerText);
  
            const formField__availability__match = formField__nativeSelect.getAttribute('data-availability-match');
            const formField__availability__notMatch = formField__nativeSelect.getAttribute('data-availability--not-match');
  
            const formField__availableInStore = obj3.settings.form.querySelector('input[name="contact[available_in_store]"]');
            /* /Availability */
            
            let itemI = 0;
  
            items.forEach((item) => {
              let itemElement;
              
              let item__availableInStore = false;
              let item__availability = formField__availability__notMatch;
  
              if (productTags.includes(item.code)) {
                item__availableInStore = true;
                item__availability = formField__availability__match;
              }
                  
              const itemText = `${item.shop} - ${item__availability}`;
  
              /* Native select item */
              itemElement = document.createElement('option');
              itemElement.setAttribute('value', item.code);
              itemElement.setAttribute('data--available-in-store', item__availableInStore);
              if(item__availableInStore){
                itemElement.style.color='#00822c'//green
              }else{
                itemElement.style.color='#969696'//gray
              }
              
              itemElement.innerHTML = itemText;
              formField__nativeSelect.append(itemElement);
              /* Native select item */
            });
  
            formField__nativeSelect.addEventListener('change', () => {
              const formField__nativeSelect__option = formField__nativeSelect.options[formField__nativeSelect.selectedIndex];
              formField__availableInStore.value = formField__nativeSelect__option.getAttribute('data--available-in-store');
            });
          }
          
          storesField__getCookieItems() {
            const obj3 = this;
            
            const cookieId = 'shopify--n8n:stores';
            
            const itemsText = window.themeObj.tools.cookie.get(cookieId);
            let newItems = [];
      
            if (itemsText) {
              const items = JSON.parse(itemsText);
              
              for (let itemKey in items) {
                newItems.push({
                  code: itemKey,
                  shop: items[itemKey]
                });
              }
            }
  
            return newItems;
          }
  
          async storesField__setCookieItems(items) {
            const obj3 = this;
  
            let newItems = {};
  
            items.forEach((item) => {
              newItems[item.code] = item.shop;
            });
            
            const cookieId = 'shopify--n8n:stores';
            window.themeObj.tools.cookie.set(cookieId, JSON.stringify(newItems));
          }
  
          async storesField__getRemoteItems() {
            const obj3 = this;
            
            const formUrl = 'https://n8n.eye-oo.com/webhook/odoo/stores/try/get';
  
            return await fetch(formUrl)
              .then((response) => {
  
                if (!response.ok) {
                  return false;
                }
                
                return response.json();
              })
                .then((response) => {
                  return response;
                });
          }
          /* /Field: Stores */
  
          /* Form: Submit */
          async form__submit() {
            const obj3 = this;
            
            obj3.settings.button.setAttribute('disabled', 'disabled');
  
            if (obj3.settings.form.checkValidity()) {
              await obj3.n8n__submit();
              
            } else {
              obj3.settings.form.reportValidity();
              obj3.settings.button.removeAttribute('disabled');
            }
          }
  
          async n8n__submit() {
            const obj3 = this;
            
            obj3.settings.button.setAttribute('disabled', 'disabled');
            
            const formFields = obj3.settings.form.querySelectorAll('[data-n8n-form--name]');
  
            if (!formFields.length) {
              return false;
            }
            
            const formBody = new FormData();
  
            formFields.forEach((formField) => {
              formField.setAttribute('value', formField.value);
  
              const formFieldNewName = formField.getAttribute('data-n8n-form--name');
              formBody.set(formFieldNewName, formField.value)
            });
  
            const formUrl = obj3.getAttribute('data-form-url');
            const formMethod = 'post';
  
            fetch(formUrl, {
              method: formMethod,
              body: formBody
            })
              .then((response) => {
              
                if (!response.ok) {
                  return false;
                }
  
                return response.json();
              })
              .then((response) => {
                
                if (!Array.isArray(response)) {
                  obj3.settings.button.removeAttribute('disabled');
    
                  return false;
                }
  
                return response;
              })
              .then((response) => {
                obj3.n8n__submitted(response);
              });
          }
  
          async n8n__submitted(items) {
            const obj3 = this;
  
            if (!items) {
              obj3.settings.button.removeAttribute('disabled');
              
              return false;
            }
  
            items.forEach((item) => {
              /* Alerts */
              const formAlerts = obj3.settings.form.querySelector('.n8n-form__alerts');
              formAlerts.innerHTML = '';
              
              if (item.message) {
                const itemElement = document.createElement('p');
                itemElement.classList.add('Form__Legend');
                
                if (item.status == 'OK') {
                  itemElement.classList.add('Form__Legend--success');
                  
                } else {
                  itemElement.classList.add('Form__Legend--error');
                }
                
                itemElement.innerHTML = item.message;
                
                formAlerts.append(itemElement);
                formAlerts.classList.remove('hide');
  
              } else {
                formAlerts.classList.add('hide');
              }
              /* /Alerts */
              
              /* Products */
              const formItems = obj3.querySelector('.n8n-form__products');
              formItems.innerHTML = '';
  
              if (item.status == 'KO' && item['products']) {
                
                item['products'].forEach((product) => {
                  const itemElement = document.createElement('div');
                  itemElement.innerHTML = `
                    <div class="n8n-form__product">
                      <div class="n8n-form__product-image">
                        <a href="${product.x_studio_url}">
                          <img
                            loading="lazy"
                            src="${product.x_studio_image_url}"
                            alt="${product.name}"
                          >
                        </a>
                      </div>
                      <div class="n8n-form__product-name">
                        <a href="${product.x_studio_url}">
                          ${product.name}
                        </a>
                      </div>
                    </div>
                  `;
                  formItems.append(itemElement);
                });
                
                formItems.classList.remove('hide');
              
              } else {
                formItems.classList.add('hide');
              }
              /* /Products */
  
              /* Fields */
              const formFields__wrapper = obj3.querySelector('.n8n-form__fields');
              formFields__wrapper.classList.add('hide');
              /* /Fields */
            });
          }
          /* /Form: Submit */
        }
  
        customElements.define('n8n-form', N8nForm);
      },
    
      productItemColors: () => {
        const obj2 = this;
  
        class ProductItemColors extends HTMLElement {
  
          settings = {
            tag: this.getAttribute('data-tag')
          }
  
          constructor() {
            super();
            
            const obj3 = this;
  
            if (obj3.classList.contains('is-rendered')) {
              return false;
            }
            
            const url = `${window.Shopify.routes.root}search?type=product&view=product-item-colors&q=${encodeURIComponent(obj3.settings.tag)}`;
            
            fetch(url, {
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              }
            })
              .then(response => {
        
                if (!response.ok) {
                  return false;
                }
        
                return response.json();
              })
              .then((response) => {
                obj3.classList.add('is-rendered');
  
                if (!response.product_colors) {
                  return false;
                }
  
                obj3.textContent = response.product_colors;
              });
          }
        }
        
        customElements.define('product-item-colors', ProductItemColors);
      },
      
      advancedFAQ: () => {
        const groupTitles = document.querySelectorAll('.Faq__GroupTitle');
  
        if (groupTitles) {
  
          for (var i = 0; i < groupTitles.length; i++) {
            const groupTitle = groupTitles[i];
  
            groupTitle.addEventListener('click', () => {
              groupTitle.classList.toggle('is-active');
            });
          }
        }
      },
      
      mediaBrandsSlider: function() {
        const brandsItemsSliderSwiper = new Swiper('.MediaBrandsSlider', {
          slidesPerView: 1,
          spaceBetween: 50,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          breakpoints: {
            321: {
              slidesPerView: 2,
              spaceBetween: 50
            },
            641: {
              slidesPerView: 2,
              spaceBetween: 50
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 50
            },
            1140: {
              slidesPerView: 6,
              spaceBetween: 50
            }
          }
        });
      },
      
      mediaCards: function() {
        const mediaCardsSwiper = new Swiper('.MediaCards', {
          slidesPerView: 4,
          spaceBetween: 35,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          breakpoints: {
            321: {
              slidesPerView: 1,
              spaceBetween: 25
            },
            641: {
              slidesPerView: 2,
              spaceBetween: 35
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 35
            },
            1140: {
              slidesPerView: 4,
              spaceBetween: 35
            }
          }
        });
      },
      
      mediaContactForm: function() {
  
        if (localStorage.getItem('shopify-section:mediaContactForm.id') && /contact_posted/.test(window.location.href)) {
          const submittedFormId = localStorage.getItem('shopify-section:mediaContactForm.id');
          const submittedForm = document.getElementById(submittedFormId);
  
          if (submittedForm) {
            window.location.hash = submittedFormId;
            const formButton = document.querySelector('.ProductMeta__ButtonBox--buttons .Button[data-action="open-modal"][aria-controls="' + submittedFormId + '"]');
            
            if (formButton) {
              formButton.click();
              
            } else {
              setTimeout(function() {
                submittedForm.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center'
                });
              }, 1000);
            }
          }
  
          localStorage.removeItem('shopify-section:mediaContactForm.id');
        }
        
        const forms = document.querySelectorAll('Form.ContactForm');
  
        if (forms) {
  
          for (var i = 0; i < forms.length; i++) {
            const form = forms[i];
            const formId = form.id;
            const formButton = form.querySelector('.Form__Submit');
  
            // form.setAttribute('action', window.location.pathname + '?contact_posted=true#' + formId);
            // form.setAttribute('method', 'get');
            
            form.addEventListener('submit', function(e) {
              e.preventDefault();
              formButton.setAttribute('disabled', 'disabled');
  
              const formUrl = form.getAttribute('action');
              const formMethod = form.getAttribute('method');
              const formBody = new FormData(form);
    
              fetch(formUrl, {
                method: formMethod,
                body: formBody,
              }).then(function (response) {
              // fetch(formUrl, {}).then(function (response) {
  
                if (response.ok) {
                  
                  if (/\/challenge$/.test(response.url)) {
                    window.location.href = response.url + '#' + formId;
  
                    localStorage.setItem('shopify-section:mediaContactForm.id', formId);
                  }
                  
                  return response.text();
                }
              
                return Promise.reject(response);
            
              }).then(function(html) {
                const parser = new DOMParser();
                const ajaxHtml = parser.parseFromString(html, 'text/html');
  
                const ajaxFormAlert = ajaxHtml.querySelector('Form#' + formId + ' .Alert');
  
                if (ajaxFormAlert) {
                  const formAlert = form.querySelector('.Alert');
  
                  if (formAlert) {
                    formAlert.remove();
                  }
  
                  form.prepend(ajaxFormAlert);
                }
              
              }).catch(function (err) {
                // There was an error
              });
            });
          }
        }
      }
    };
    
    window.themeObj.templates = {
      
      init: function() {
  
        if (document.body.classList.contains('template-product')) {
          window.themeObj.templates.product();
        
        } else if (document.body.classList.contains('template-page')) {
          window.themeObj.templates.page.init();
        }
      },
      
      page: {
        
        init: function() {
          window.themeObj.templates.page.event();
  
          const brandsLetterLinks = document.querySelectorAll('.MediaBrands__LetterLink');
          
          if (brandsLetterLinks) {
  
            for (var i = 0; i < brandsLetterLinks.length; i++) {
              const brandsLetterLink = brandsLetterLinks[i];
  
              brandsLetterLink.addEventListener('click', function() {
                const brandsLetter = document.querySelector('#brandsLetter-' + brandsLetterLink.getAttribute('data-letter'));
                brandsLetter.scrollIntoView();
  
                const headerHeight = document.querySelector('#shopify-section-header').offsetHeight;
  
                window.scrollTo(
                  {
                    top: brandsLetter.getBoundingClientRect().top - headerHeight - 20 + window.scrollY,
                    behavior: 'smooth'
                  }
                );
              });
            }
          }
        },
        
        event: function() {
          // const brandsLetters = document.querySelectorAll('.MediaBrands__LetterLink');
  
          // if (brandsLetters) {
  
          //   for (var i = 0; i < brandsLetters.length; i++) {
          //     const brandsLetter = brandsLetters[i];
          //   }
          // }
        }
      },
      
      product: function() {
        const accordionTitles = document.querySelectorAll('.ProductForm__AccordionTitle');
  
        if (accordionTitles) {
  
          for (var i = 0; i < accordionTitles.length; i++) {
            const accordionTitle = accordionTitles[i];
            accordionTitle.addEventListener('click', function() {
              
              if (accordionTitle.classList.contains('is-active')) {
                accordionTitle.classList.remove('is-active');
                
              } else {
                accordionTitle.classList.add('is-active');
              }
            });
          }
        }
  
        const activeProductVariantsSlider = document.querySelector('.HorizontalList__Item--colorLink.is-active');
  
        if (activeProductVariantsSlider) {
          const productVariantsSliderSwiper = new Swiper('.SizeSwatchList__Swiper', {
            slidesPerView: 6,
            initialSlide: parseInt(activeProductVariantsSlider.getAttribute('data-index')) -2,
            spaceBetween: 0,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            breakpoints: {
              321: {
                slidesPerView: 5,
                spaceBetween: 0
              },
              641: {
                slidesPerView: 5,
                spaceBetween: 0
              },
              768: {
                slidesPerView: 5,
                spaceBetween: 0
              },
              1140: {
                slidesPerView: 6,
                spaceBetween: 0
              }
            }
          });
        }
        
        const form = document.querySelector('.ProductForm');
        const addToCart = form.querySelector('.ProductForm__AddToCart');
  
        const productVariants = document.querySelectorAll('.ProductForm__Variants .SizeSwatch__Radio');
  
        if (productVariants) {
  
          for (var i = 0; i < productVariants.length; i++) {
            const productVariant = productVariants[i];
  
            productVariant.addEventListener('change', function() {
              form.classList.remove('ProductForm--disabled');
              
              const productButtonBoxModal = document.querySelector('.ProductMeta__ButtonBox--modal');
  
              if (productButtonBoxModal) {
                productButtonBoxModal.classList.add('ProductMeta__ButtonBox--disabled');
              }
            });
          }
        }
  
        /* Product meta: form */
        const productMetaForms = document.querySelectorAll('.ProductMeta__ProductForm');
  
        if (productMetaForms) {
          const productDescription = document.querySelector('.ProductMeta__Description');
  
          for (var i = 0; i < productMetaForms.length; i++) {
            const productMetaForm = productMetaForms[i];
            const productMetaFormId = productMetaForm.getAttribute('data-form-id');
            const productMetaFormContent = document.querySelector('#' + productMetaFormId);
  
            if (productMetaFormContent) {
              productMetaForm.append(productMetaFormContent);
            }
          }
        }
        /* /Product meta: form */
      }
    };
  
  document.addEventListener('DOMContentLoaded', () => {
    window.themeObj.init();
  });
  
})();
/* /vDEV */